(() => {
  const sectionSelector = '.landing-b2b-contact-form';
  const modalOpenClass = 'landing-b2b-contact-form-modal-open';

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const showError = (field, message) => {
    const form = field.closest('form');
    const error = form?.querySelector(`[data-error-for="${field.id}"]`);

    field.classList.add('landing-b2b-contact-form__input--error');
    field.setAttribute('aria-invalid', 'true');

    if (error) {
      error.textContent = message;
      error.classList.add('is-visible');
    }
  };

  const clearError = (field) => {
    const form = field.closest('form');
    const error = form?.querySelector(`[data-error-for="${field.id}"]`);

    field.classList.remove('landing-b2b-contact-form__input--error');
    field.removeAttribute('aria-invalid');

    if (error) {
      error.textContent = '';
      error.classList.remove('is-visible');
    }
  };

  const validateField = (field) => {
    const value = field.value.trim();

    clearError(field);

    if (field.hasAttribute('required') && !value) {
      showError(field, field.dataset.requiredMessage || 'This field is required.');
      return false;
    }

    if (field.type === 'email' && value && !emailPattern.test(value)) {
      showError(field, field.dataset.emailMessage || 'Please enter a valid email address.');
      return false;
    }

    return true;
  };

  const openModal = (section) => {
    const modal = section.querySelector('[data-contact-modal]');
    const dialog = modal?.querySelector('[role="dialog"]');

    if (!modal) return;

    modal.classList.add('is-visible');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(modalOpenClass);

    window.setTimeout(() => {
      dialog?.focus();
    }, 0);
  };

  const closeModal = (section) => {
    const modal = section.querySelector('[data-contact-modal]');

    if (!modal) return;

    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden', 'true');

    if (!document.querySelector('.landing-b2b-contact-form__modal.is-visible')) {
      document.documentElement.classList.remove(modalOpenClass);
    }
  };

  const initModal = (section) => {
    const modal = section.querySelector('[data-contact-modal]');

    if (!modal || modal.dataset.modalInitialized === 'true') return;

    modal.dataset.modalInitialized = 'true';

    modal.querySelectorAll('[data-contact-modal-close]').forEach((button) => {
      button.addEventListener('click', () => closeModal(section));
    });
  };

  const setSubmittingState = (form, isSubmitting) => {
    const submitButton = form.querySelector('[type="submit"]');

    form.classList.toggle('is-submitting', isSubmitting);
    form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');

    if (submitButton) {
      submitButton.disabled = isSubmitting;
      submitButton.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    }
  };

  const initFormValidation = (section) => {
    const form = section.querySelector('.landing-b2b-contact-form__form');

    if (!form || form.dataset.validationInitialized === 'true') return;

    form.setAttribute('method', 'post');
    form.setAttribute('novalidate', 'novalidate');
    form.removeAttribute('target');
    form.dataset.validationInitialized = 'true';

    const fields = form.querySelectorAll('input[required], select[required], input[type="email"]');

    fields.forEach((field) => {
      field.addEventListener('blur', () => validateField(field));

      field.addEventListener('input', () => {
        if (field.classList.contains('landing-b2b-contact-form__input--error')) {
          validateField(field);
        }
      });

      field.addEventListener('change', () => validateField(field));
    });

    form.addEventListener(
      'submit',
      (event) => {
        if (form.dataset.isSubmitting === 'true') {
          event.preventDefault();
          return false;
        }

        let isValid = true;
        let firstInvalidField = null;

        fields.forEach((field) => {
          const fieldIsValid = validateField(field);

          if (!fieldIsValid && !firstInvalidField) {
            firstInvalidField = field;
          }

          if (!fieldIsValid) {
            isValid = false;
          }
        });

        if (!isValid) {
          event.preventDefault();
          event.stopPropagation();

          firstInvalidField?.focus();
          return false;
        }

        form.dataset.isSubmitting = 'true';
        setSubmittingState(form, true);

        return true;
      },
      true,
    );
  };

  const openSuccessModalAfterReload = (section) => {
    const successMessage = section.querySelector('[data-contact-success]');
    const form = section.querySelector('.landing-b2b-contact-form__form');
    const params = new URLSearchParams(window.location.search);

    const hasShopifySuccessParam = params.get('contact_posted') === 'true';
    const hashMatchesForm = form?.id && window.location.hash === `#${form.id}`;

    if (!successMessage && !(hasShopifySuccessParam && hashMatchesForm)) return;

    openModal(section);

    if (window.history?.replaceState && hasShopifySuccessParam) {
      const url = new URL(window.location.href);

      url.searchParams.delete('contact_posted');

      window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
    }
  };

  const initSection = (section) => {
    initModal(section);
    initFormValidation(section);
    openSuccessModalAfterReload(section);
  };

  const init = () => {
    document.querySelectorAll(sectionSelector).forEach(initSection);
  };

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll(sectionSelector).forEach((section) => {
      closeModal(section);
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches?.(sectionSelector)
      ? event.target
      : event.target.querySelector(sectionSelector);

    if (section) {
      initSection(section);
    }
  });
})();
